module.exports = __webpack_public_path__ + "img/mi-check_box--sharp.a1e1ac67.svg";